import { Collapse, Typography } from '@material-ui/core'
import ArrowRightIcon from '@material-ui/icons/ArrowRight'

import { Channel } from '../../../types/channel'
import {
  ChannelInventoryData,
  RatePlanForInventory
} from '../../../types/inventory'
import useStyles from './styles/index.styles'

interface RatePlanTitelProps {
  ratePlanItem: RatePlanForInventory
  channelData: ChannelInventoryData[]
  channels: Channel[]
  showChannels: boolean
  setshowChannels: (v: boolean) => void
  onClick: (s: string, d: string) => void
  roomtypeCode: string
  providerCode: string
}

const RatePlanTitle = ({
  ratePlanItem,
  channelData,
  channels,
  setshowChannels,
  showChannels,
  onClick,
  roomtypeCode,
  providerCode
}: RatePlanTitelProps) => {
  const classes = useStyles()

  return (
    <>
      <div
        className={classes.rateplanRowNameContainer}
        onClick={() => {
          onClick(roomtypeCode, providerCode)
          setshowChannels(!showChannels)
        }}>
        <Typography variant="body1" className={classes.rowName}>
          {`${ratePlanItem.basicDetails.name}  
          ${ratePlanItem.basicDetails.displayRatePlanCode}`}
        </Typography>

        <ArrowRightIcon
          onClick={() => {
            onClick(roomtypeCode, providerCode)
            setshowChannels(!showChannels)
          }}
          className={[
            classes.channelArrowRight,
            showChannels ? classes.channelArrowRightCollapsed : ''
          ].join(' ')}
        />
      </div>
      <Collapse in={showChannels}>
        {channelData
          .filter((channel) =>
            channel.ratePlans.some(
              (rp) =>
                rp.basicDetails.displayRatePlanCode ===
                ratePlanItem.basicDetails.displayRatePlanCode
            )
          )
          .map((channelItem: ChannelInventoryData) => (
            <div
              className={classes.channelRowNameContainer}
              key={channelItem.channelID}>
              <Typography variant="body1" className={classes.rowName}>
                {channels.find(
                  (channel) =>
                    channel.basicDetails.channelID === channelItem.channelID
                )?.basicDetails.name || ''}
              </Typography>
            </div>
          ))}
      </Collapse>
    </>
  )
}

export default RatePlanTitle
